import { useEffect, useRef, useState } from 'react'
import apiClient from '../utils/apiClient'

export default function useAddressSuggestions() {
	const [suggestions, setSuggestions] = useState([])
	const [loading, setLoading] = useState(false)
	const [open, setOpen] = useState(false)
	const [error, setError] = useState('')
	const request = useRef({ generation: 0, controller: null })

	useEffect(() => () => {
		request.current.generation += 1
		request.current.controller?.abort()
	}, [])

	function clear() {
		request.current.generation += 1
		request.current.controller?.abort()
		setSuggestions([])
		setLoading(false)
		setOpen(false)
		setError('')
	}

	async function search(value) {
		clear()
		if (value.trim().length <= 3) return
		const generation = request.current.generation
		const controller = new AbortController()
		request.current.controller = controller
		setLoading(true)
		try {
			const response = await apiClient.post('/api/dadata/suggest', { query: value }, {
				signal: controller.signal,
			})
			if (generation !== request.current.generation) return
			if (!Array.isArray(response.data)) throw new Error('INVALID_SUGGESTIONS')
			setSuggestions(response.data)
			setOpen(response.data.length > 0)
		} catch {
			if (generation !== request.current.generation) return
			setError('Не удалось загрузить адресные подсказки. Повторите ввод.')
		} finally {
			if (generation === request.current.generation) setLoading(false)
		}
	}

	return { suggestions, loading, open, setOpen, error, search, clear }
}
